import { render, staticRenderFns } from "./ChinaumsBalance.vue?vue&type=template&id=128de9f0&scoped=true"
import script from "./ChinaumsBalance.vue?vue&type=script&lang=js"
export * from "./ChinaumsBalance.vue?vue&type=script&lang=js"
import style0 from "./ChinaumsBalance.vue?vue&type=style&index=0&id=128de9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128de9f0",
  null
  
)

export default component.exports